import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { ScoreBreakdown } from '@tailorcast/shared-types';

export function useProductScores(productId: string | undefined) {
  return useQuery({
    queryKey: ['product', productId, 'scores'],
    queryFn: () => api.get<ScoreBreakdown>(COMMERCE.PRODUCT_SCORE(productId!)),
    enabled: !!productId,
  });
}
